// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type SaveMapItemsStepMutationVariables = Types.Exact<{
  input: Types.SaveScheduleTemplateItemMappingsInput;
}>;


export type SaveMapItemsStepMutation = { __typename?: 'Mutation', saveScheduleTemplateItemMappings: { __typename?: 'SaveScheduleTemplateItemMappingsResult', scheduleTemplateItemMappings: Array<{ __typename?: 'ScheduleTemplateItemMapping', id: string }> } };

export type CostMappingScheduleTasksQueryVariables = Types.Exact<{
  scheduleTemplateId: Types.Scalars['ID']['input'];
}>;


export type CostMappingScheduleTasksQuery = { __typename?: 'Query', scheduleTasks: Array<{ __typename?: 'ScheduleTask', id: string, name: string }> };


export const SaveMapItemsStepDocument = gql`
    mutation SaveMapItemsStep($input: SaveScheduleTemplateItemMappingsInput!) {
  saveScheduleTemplateItemMappings(input: $input) {
    scheduleTemplateItemMappings {
      id
    }
  }
}
    `;

/**
 * __useSaveMapItemsStepMutation__
 *
 * To run a mutation, you first call `useSaveMapItemsStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMapItemsStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMapItemsStepMutation, { data, loading, error }] = useSaveMapItemsStepMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveMapItemsStepMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveMapItemsStepMutation, SaveMapItemsStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveMapItemsStepMutation, SaveMapItemsStepMutationVariables>(SaveMapItemsStepDocument, options);
      }
export type SaveMapItemsStepMutationHookResult = ReturnType<typeof useSaveMapItemsStepMutation>;
export type SaveMapItemsStepMutationResult = ApolloReactCommon.MutationResult<SaveMapItemsStepMutation>;
export const CostMappingScheduleTasksDocument = gql`
    query CostMappingScheduleTasks($scheduleTemplateId: ID!) {
  scheduleTasks(filter: {scheduleParent: [$scheduleTemplateId]}, first: 10000) {
    id
    name
  }
}
    `;

/**
 * __useCostMappingScheduleTasksQuery__
 *
 * To run a query within a React component, call `useCostMappingScheduleTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useCostMappingScheduleTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCostMappingScheduleTasksQuery({
 *   variables: {
 *      scheduleTemplateId: // value for 'scheduleTemplateId'
 *   },
 * });
 */
export function useCostMappingScheduleTasksQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CostMappingScheduleTasksQuery, CostMappingScheduleTasksQueryVariables> & ({ variables: CostMappingScheduleTasksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CostMappingScheduleTasksQuery, CostMappingScheduleTasksQueryVariables>(CostMappingScheduleTasksDocument, options);
      }
export function useCostMappingScheduleTasksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CostMappingScheduleTasksQuery, CostMappingScheduleTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CostMappingScheduleTasksQuery, CostMappingScheduleTasksQueryVariables>(CostMappingScheduleTasksDocument, options);
        }
// @ts-ignore
export function useCostMappingScheduleTasksSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CostMappingScheduleTasksQuery, CostMappingScheduleTasksQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CostMappingScheduleTasksQuery, CostMappingScheduleTasksQueryVariables>;
export function useCostMappingScheduleTasksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CostMappingScheduleTasksQuery, CostMappingScheduleTasksQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CostMappingScheduleTasksQuery | undefined, CostMappingScheduleTasksQueryVariables>;
export function useCostMappingScheduleTasksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CostMappingScheduleTasksQuery, CostMappingScheduleTasksQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CostMappingScheduleTasksQuery, CostMappingScheduleTasksQueryVariables>(CostMappingScheduleTasksDocument, options);
        }
export type CostMappingScheduleTasksQueryHookResult = ReturnType<typeof useCostMappingScheduleTasksQuery>;
export type CostMappingScheduleTasksLazyQueryHookResult = ReturnType<typeof useCostMappingScheduleTasksLazyQuery>;
export type CostMappingScheduleTasksSuspenseQueryHookResult = ReturnType<typeof useCostMappingScheduleTasksSuspenseQuery>;
export type CostMappingScheduleTasksQueryResult = ApolloReactCommon.QueryResult<CostMappingScheduleTasksQuery, CostMappingScheduleTasksQueryVariables>;